var map = {
	"./fondo.png": 4288,
	"./fondo_sin_fondo.png": 9446,
	"./googlePrueba.png": 6893,
	"./header.png": 4068,
	"./header_movil.png": 4199,
	"./logo.png": 6949,
	"./moviles.png": 7061,
	"./moviles2.png": 9384,
	"./promos.png": 3842,
	"./promos2.png": 1342,
	"./retail.png": 3596
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5675;